// @flow

import * as React from 'react';

import { LongWordBreaker, RemoveButton } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Button } from '@gandi/ui';

import styles from './Suggestion.scss';

export type Props = {
  title: string,
  price: string,
  description?: string,
  children?: React.Node,
  onAddToCart: (SyntheticEvent<>) => mixed,
  onHide?: (SyntheticEvent<>) => mixed, // Disabled for now.
};

export default function Suggestion({
  title,
  price,
  description,
  children,
  onAddToCart,
  onHide,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base
      backgroundColor="white"
      padding="small"
      bordered
      borderColor="grey"
      className={styles.root}
      flex
      flexCol
      flexShrink1
    >
      <Base flex gap="xsmall" flexAlignItemsBaseline marginBottom="xxsmall">
        <Base>
          <LongWordBreaker>{title}</LongWordBreaker>
        </Base>
        <Base flexExpandLeft>{price}</Base>
        {onHide && <RemoveButton handleRemoveAction={onHide} />}
      </Base>
      {description && <Base size="small">{description}</Base>}
      {!!children && (
        <Base size="small" marginTop="xsmall">
          {children}
        </Base>
      )}
      <Button
        marginTop="xsmall"
        flexExpandLeft
        kind="outline"
        iconAfter="cart"
        onClick={onAddToCart}
        small
      >
        {__('Add to cart')}
      </Button>
    </Base>
  );
}
